import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import config from "../config";

export class S3Uploader {
    constructor(idToken) {
        this.client = new S3Client({
            region: config.awsRegion,
            credentials: fromCognitoIdentityPool({
                client: new CognitoIdentityClient({ region: config.awsRegion }),
                identityPoolId: config.cognitoIdentityPoolId,
                logins: {
                    [`cognito-idp.${config.awsRegion}.amazonaws.com/${config.cognitoUserPoolId}`]:
                        idToken,
                },
            }),
        });
    }

    async uploadFile(bucket, key, file, contentType) {
        const params = {
            Bucket: bucket,
            Key: key,
            Body: file,
            ContentType: contentType,
        };
        await this.client.send(new PutObjectCommand(params));
    }
}
